export default {
      id: "tiktok-usage",
      viewBox: "0 0 26 29",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#tiktok",
      toString: function () {
        return this.url;
      }
    }